export const state = {
  messages: [],
  page: 1,
  take: 20,
  allMessagesLoaded: false
};
